function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8914 4.0426L3.25199 8.85062L4.60841 9.79563C5.71595 10.5672 6.21461 11.9189 5.86152 13.1924L5.77337 13.5103L13.8914 4.0426ZM6.97466 15.4308L9.433 14.706C10.4175 14.4157 11.486 14.5868 12.3206 15.1683L13.6822 16.1169L15.9891 4.91759L6.97466 15.4308ZM13.7832 18.7988C14.4309 19.2502 15.3453 18.9031 15.5012 18.1467L18.9779 1.26748C19.1533 0.416179 18.2512 -0.265953 17.4368 0.102097L0.631944 7.69638C-0.125861 8.03881 -0.223408 9.04121 0.455082 9.51387L3.32434 11.5127C3.69352 11.7699 3.85973 12.2205 3.74204 12.6449L2.45587 17.284C2.23323 18.0871 3.01236 18.8133 3.8361 18.5704L10.074 16.7313C10.4021 16.6345 10.7583 16.6916 11.0365 16.8854L13.7832 18.7988Z",
  fill: "#18CDA6"
});

var SvgTelegram = function SvgTelegram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram.edaa97d9.svg";
export { ForwardRef as ReactComponent };